export async function clearData(table) {
    await table.clear();
}
